

























































































































































































































































































































































































































import skillbar from '@/components/skillbar.vue';
import dayJs from 'dayjs';
import { ref, defineComponent, onMounted, computed } from '@vue/composition-api';
import store from '@/store';
import Apierrormessage from '@/components/Apierrormessage.vue';
import modal from '@/components/GenericModal.vue';
import Vue from 'vue';

const bus = new Vue();
// import { bus } from '@/main';
// import router from '@/router';

// const crypto = require('crypto');

const isLocal = process.env.VUE_APP_RUN_ENV === 'local';
const isProd = process.env.VUE_APP_BUILD === 'production';

export default defineComponent({
  name: 'Summary',
  components: {
    skillbar,
    Apierrormessage,
    modal,
  },
  setup() {
    const renderReady = ref(false);
    const baseUrl = ref('');
    const apiError = ref(false);
    const isChangeRole = ref(false);
    const isButtonCheck = ref(false);
    const pdfDownloading = ref(false);
    const openProfDefModal = ref(false);
    const openShareModal = ref(false);
    onMounted(async () => {
      await store.dispatch('profile/getEmployeeProfile');
      await store.dispatch('profile/getSkillsProficiency');
      renderReady.value = true;
    });
    const skillsEmployeeProfile = computed(() => store.getters['profile/skillsEmployeeProfile']);
    const skillsLevels = computed(() => store.getters['profile/skillsLevels']);
    const shareableUrl = () => {
      const mystr = btoa(skillsEmployeeProfile?.value.ohrid);
      return `${baseUrl}/share-profile?id=${mystr}`;
    };
    const proceedToNextTab = (path: any) => {
      if (!skillsEmployeeProfile.value.profileComplete && !skillsEmployeeProfile.value.isLegacy && !isChangeRole.value) {
        isButtonCheck.value = true;
        bus.$emit('proceedToNextPage', isChangeRole, isButtonCheck);
      } else if (isChangeRole.value) {
        // Denots only click on previous tab
        // @ts-ignore
        this.$router.push(path);
      }
    };
    const formatDate = (value: any) => {
      if (value) {
        return dayJs(String(value)).format('MMM DD YYYY');
      }
      return '';
    };
    const copyprofilurl = () => {
      // const copyText = document.getElementById('shareableUrlInput');
      // copyText.select();
      // copyText.setSelectionRange(0, 99999);
      try {
        document.execCommand('copy');
      } catch (err) {
        alert('Oops, unable to copy');
      }
    };
    // const downloadprofile = async () => {
    //   const { firstName, lastName, ohrId } = userinformation;
    //   const url = `${window.location.href}&firstName=${firstName}&lastName=${lastName}&ohrId=${ohrId}&ssoToken=${localStorage.getItem('accessToken')}`;
    //   pdfDownloading.value = true;
    //   try {
    //     const { data } = await axios.post('/api/utility/v1/generate-pdf', { url }, { responseType: 'arraybuffer' });
    //     const newBlob = new Blob([data], { type: 'application/pdf' });
    //     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //       const fileName = 'genome_profile_summary.pdf';
    //       window.navigator.msSaveOrOpenBlob(newBlob, fileName);
    //       pdfDownloading.value = false;
    //     } else {
    //       const datapdf = window.URL.createObjectURL(newBlob);
    //       const link = document.createElement('a');
    //       link.href = datapdf;
    //       link.download = 'genome_profile_summary.pdf';
    //       link.click();
    //       pdfDownloading.value = false;
    //     }
    //   } catch (e) {
    //     console.warn(e);
    //     alert('Generating PDF failed: ', e.message);
    //     pdfDownloading.value = false;
    //   }
    // };
    return {
      baseUrl: isProd ? 'https://genome.genpact.com' : 'https://gencinduatgenomewapp.azurewebsites.net',
      skillsEmployeeProfile,
      shareableUrl,
      formatDate,
      apiError,
      skillsLevels,
      renderReady,
      isChangeRole,
      copyprofilurl,
      isLocal,
      pdfDownloading,
      openProfDefModal,
      openShareModal,
      proceedToNextTab,
      bus,
    };
  },
  // methods: {
  //   formatDate(value) {
  //     if (value) {
  //       return dayJs(String(value)).format('MMM DD YYYY');
  //     }
  //     return '';
  //   },
  // },
  //   methods: {
  //     ...mapActions(['getSkillsLevels', 'getSkillsFluencies', 'getSkillsEmployeeProfile']),
  //     formatDate(value) {
  //       if (value) {
  //         return dayJs(String(value)).format('MMM DD YYYY');
  //       }
  //       return '';
  //     },
  //     onClickChild(number) {
  //       this.routPage = number;
  //       if (this.skillsEmployeeProfile.ProfileCompleted && !this.skillsEmployeeProfile.IsLegacyUser && !this.isChangeRole) {
  //         this.isButtonCheck = true;
  //         this.proceedToNextPage();
  //       }
  //       if (this.isChangeRole) {
  //         this.$router.push(`/my-profile?page=${number}`);
  //       }
  //     },
  //     async proceedToNextPage() {
  //       const page = parseInt(this.$route.query.page || 0, 10);
  //       switch (page) {
  //         case 1:
  //           this.selectedFunctionValidation(page);
  //           break;
  //         case 2:
  //           this.domainAndServiceLineValidation3('industry', page);
  //           break;
  //         case 3:
  //           this.domainAndServiceLineValidation3('domain', page);
  //           break;
  //         case 4:
  //           this.domainAndServiceLineValidation3('digital', page);
  //           break;
  //         case 5:
  //           this.professionalValidation2(page);
  //           break;
  //         default:
  //           break;
  //       }
  //       if (page < 1) {
  //         this.$router.push(`/my-profile?page=${page + 1}`);
  //       }
  //       if (this.$route.query.page === 'summary' && !this.isChangeRole) {
  //         this.$router.push(`/my-profile?page=${this.routPage}`);
  //       }
  //     },
  //     openProfilesharemodal() {
  //       this.$refs['profileshare-modal'].$data.isOpen = true;
  //     },
  //     openProfdefinitionmodal() {
  //       this.$refs['profdefinition-modal'].$data.isOpen = true;
  //     },
  //     async downloadprofile() {
  //       const { firstName, lastName, ohrId } = this.userinformation;
  //       const url = `${window.location.href}&firstName=${firstName}&lastName=${lastName}&ohrId=${ohrId}&ssoToken=${localStorage.getItem('accessToken')}`;
  //       this.pdfDownloading = true;
  //       try {
  //         const { data1 } = await this.$http.post('/api/utility/v1/generate-pdf', { url }, { responseType: 'arraybuffer' });
  //         const newBlob = new Blob([data1], { type: 'application/pdf' });
  //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
  //           const fileName = 'genome_profile_summary.pdf';
  //           window.navigator.msSaveOrOpenBlob(newBlob, fileName);
  //           this.pdfDownloading = false;
  //         } else {
  //           const datapdf = window.URL.createObjectURL(newBlob);
  //           const link = document.createElement('a');
  //           link.href = datapdf;
  //           link.download = 'genome_profile_summary.pdf';
  //           link.click();
  //           this.pdfDownloading = false;
  //         }
  //       } catch (e) {
  //         console.warn(e);
  //         alert('Generating PDF failed: ', e.message);
  //         this.pdfDownloading = false;
  //       }
  //     },
  //     copyprofilurl() {
  //       const copyText = document.getElementById('shareableUrlInput');
  //       copyText.select();
  //       copyText.setSelectionRange(0, 99999);
  //       try {
  //         document.execCommand('copy');
  //       } catch (err) {
  //         alert('Oops, unable to copy');
  //       }
  //     },
  //   },
});
